import Vue from 'vue'
import Router from 'vue-router'
const _import = require('./_import_' + process.env.NODE_ENV);
import MyHome from '../views/index/index.vue'
Vue.use(Router)

let router = new Router({
  routes: [
    {
      path:'/',
      component:_import('/index/index')
    }, {
      path: '/index',
      component: MyHome,
      name: 'index'
    }
  ]
})
export default router
